<template>
  <el-dialog
    :visible="visible"
    @update:visible="(v) => $emit('update:visible', v)"
    :show-close="true"
    width="520px"
    :close-on-click-modal="false"
    :append-to-body="true"
    :modal-append-to-body="true"
    custom-class="prefix-dialog"
  >
    <div slot="title" style="display:flex;align-items:center;gap:12px;">
      <span style="display:inline-block;width:3px;height:18px;background:#28C76F;border-radius:2px;"></span>
      <span style="font-weight:700;letter-spacing:-0.2px;">
        {{ mode === 'create' ? 'GS1 프리픽스 신규 등록' : 'GS1 프리픽스 수정' }}
      </span>
      <span style="font-size:11px;opacity:0.45;font-family:monospace;text-transform:uppercase;letter-spacing:0.6px;">UPC / EAN</span>
    </div>

    <div v-if="mode === 'edit'"
      style="padding:14px 16px;border:1px solid rgba(40,199,111,0.2);background:rgba(40,199,111,0.04);border-radius:6px;margin-bottom:18px;display:flex;align-items:center;justify-content:space-between;gap:16px;">
      <div style="min-width:0;">
        <p style="font-size:10px;text-transform:uppercase;letter-spacing:0.8px;opacity:0.45;font-weight:600;margin:0 0 4px;">등록된 프리픽스</p>
        <p style="font-family:monospace;font-weight:700;font-size:17px;margin:0;letter-spacing:0.5px;">{{ form.prefix }}</p>
      </div>
      <div style="text-align:right;">
        <p style="font-size:10px;text-transform:uppercase;letter-spacing:0.8px;opacity:0.45;font-weight:600;margin:0 0 4px;">시퀀스 용량</p>
        <p style="font-weight:700;font-size:15px;margin:0;font-family:monospace;">000 — {{ String(form.max_sequence - 1).padStart(3,'0') }}</p>
      </div>
    </div>

    <div v-if="mode === 'create'" style="margin-bottom:6px;">
      <label style="display:block;font-size:11px;text-transform:uppercase;letter-spacing:0.8px;opacity:0.55;font-weight:600;margin-bottom:6px;">프리픽스</label>
      <el-input v-model="form.prefix" maxlength="9" placeholder="880123456" size="medium">
        <template slot="prepend"><span style="font-family:monospace;font-size:11px;opacity:0.6;">9자리</span></template>
      </el-input>
      <p v-if="errors.prefix" style="color:#EA5455;font-size:11px;margin:6px 0 0;">{{ errors.prefix }}</p>
      <p v-else style="font-size:11px;opacity:0.4;margin:6px 0 0;">GS1 회사 코드 (UPC-A 12자리 중 앞 9자리) · 시퀀스 000–999 자동 발급 (총 1,000개)</p>
    </div>

    <div v-if="mode === 'create'" style="margin:14px 0 18px;padding:12px 14px;background:rgba(0,0,0,0.04);border-radius:6px;border-left:2px solid #28C76F;">
      <p style="font-size:10px;text-transform:uppercase;letter-spacing:0.8px;opacity:0.5;font-weight:600;margin:0 0 6px;">생성될 코드 범위</p>
      <p style="margin:0;font-family:monospace;font-size:13px;font-weight:600;">
        <span :style="{opacity: previewValid ? 1 : 0.3}">{{ previewStart }}</span>
        <span style="opacity:0.4;margin:0 8px;">→</span>
        <span :style="{opacity: previewValid ? 1 : 0.3}">{{ previewEnd }}</span>
        <span v-if="previewValid" style="opacity:0.5;font-size:11px;margin-left:10px;">총 {{ form.max_sequence.toLocaleString() }}개</span>
      </p>
    </div>

    <div>
      <label style="display:block;font-size:11px;text-transform:uppercase;letter-spacing:0.8px;opacity:0.55;font-weight:600;margin-bottom:6px;">설명 <span style="opacity:0.5;text-transform:none;letter-spacing:0;font-weight:500;">(선택)</span></label>
      <el-input v-model="form.description" type="textarea" :rows="2" maxlength="200" show-word-limit
        placeholder="예: 2026년 신규 발급분" />
    </div>

    <div v-if="mode === 'edit'" style="margin-top:18px;padding-top:16px;border-top:1px solid rgba(0,0,0,0.06);display:flex;align-items:center;justify-content:space-between;">
      <div>
        <p style="font-size:11px;text-transform:uppercase;letter-spacing:0.8px;opacity:0.55;font-weight:600;margin:0 0 2px;">활성 상태</p>
        <p style="font-size:11px;opacity:0.4;margin:0;">새 코드 발급에 이 프리픽스를 사용할지 여부</p>
      </div>
      <el-switch v-model="form.is_active" active-color="#28C76F" />
    </div>

    <span slot="footer" style="display:flex;justify-content:flex-end;gap:8px;">
      <el-button size="small" @click="$emit('update:visible', false)">취소</el-button>
      <el-button type="primary" size="small" :loading="submitting" @click="submit"
        style="background:#28C76F;border-color:#28C76F;">
        {{ mode === 'create' ? '등록' : '저장' }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { Dialog, Switch } from 'element-ui'

export default {
  name: 'PrefixFormDialog',

  components: {
    [Dialog.name]: Dialog,
    [Switch.name]: Switch,
  },

  props: {
    visible: { type: Boolean, default: false },
    mode: { type: String, default: 'create' },
    prefix: { type: Object, default: null },
  },

  data() {
    return {
      form: this.defaultForm(),
      errors: {},
      submitting: false,
    }
  },

  computed: {
    previewValid() {
      return /^\d{9}$/.test(this.form.prefix || '')
    },
    previewStart() {
      const p = /^\d{9}$/.test(this.form.prefix || '') ? this.form.prefix : '─────────'
      return `${p}-000`
    },
    previewEnd() {
      const p = /^\d{9}$/.test(this.form.prefix || '') ? this.form.prefix : '─────────'
      const max = this.previewValid ? String(this.form.max_sequence - 1).padStart(3, '0') : '───'
      return `${p}-${max}`
    },
  },

  watch: {
    visible(val) {
      if (val) this.hydrate()
    },
  },

  methods: {
    defaultForm() {
      return { id: null, prefix: '', max_sequence: 1000, description: '', is_active: true }
    },

    hydrate() {
      this.errors = {}
      if (this.mode === 'edit' && this.prefix) {
        this.form = {
          id: this.prefix.id,
          prefix: this.prefix.prefix,
          max_sequence: this.prefix.max_sequence,
          description: this.prefix.description || '',
          is_active: !!this.prefix.is_active,
        }
      } else {
        this.form = this.defaultForm()
      }
    },

    validate() {
      const errors = {}
      if (this.mode === 'create') {
        if (!/^\d{9}$/.test(this.form.prefix || '')) {
          errors.prefix = '숫자 9자여야 합니다.'
        }
      }
      this.errors = errors
      return Object.keys(errors).length === 0
    },

    submit() {
      if (!this.validate()) return
      this.submitting = true
      const action = this.mode === 'create'
        ? this.$store.dispatch('POST_BARCODE_PREFIX', {
            prefix: this.form.prefix,
            max_sequence: Number(this.form.max_sequence),
            description: this.form.description || null,
          })
        : this.$store.dispatch('PATCH_BARCODE_PREFIX', {
            id: this.form.id,
            params: {
              is_active: this.form.is_active,
              description: this.form.description || null,
            },
          })

      action
        .then(() => {
          this.$notify({
            type: 'success',
            message: this.mode === 'create' ? '프리픽스를 등록했습니다.' : '프리픽스를 수정했습니다.',
          })
          this.$emit('submitted')
          this.$emit('update:visible', false)
        })
        .catch((err) => {
          const msg = (err && err.response && err.response.data && err.response.data.error) || '저장에 실패했습니다.'
          this.$notify({ type: 'danger', message: msg })
        })
        .finally(() => { this.submitting = false })
    },
  },
}
</script>
